module.exports = __webpack_public_path__ + "static/media/20130613_660275_347281.1ef628f9.mp3";